export const geoKeys = {
  all: ["geo"] as const,
  countryCode: () => [...geoKeys.all, "country-code"] as const,
};
